'use client'

interface WhiteSpaceProps {
  length?: number
}

/** Use this instead of {' '} */
export const WhiteSpace = ({ length = 1 }: WhiteSpaceProps) => (
  <span>{'\u00A0'.repeat(length)}</span>
)
